
export interface INDRAFlightPriceInCash {
	amount: number;
	currency: string;
}

export interface INDRAFlightPriceInMiles {
	amount: number;
	currency: string;
}

export interface INDRAFlightTax {
	amount: number;
	currency: string;
}

export interface INDRAOtherFlightCost {
	amount: number;
	currency: string;
}

export class INDRAFlightPrice {
	private cash: INDRAFlightPriceInCash;
	private miles: INDRAFlightPriceInMiles;
	private tax: INDRAFlightTax;
	private isBookAward: boolean;

	constructor(flightCost, tax, currency, isBookAward) {
		this.isBookAward = isBookAward === null || isBookAward === undefined ? false : isBookAward;
		this._setFlightPriceInCash(flightCost, currency);
		this._setFlightTax(tax, currency);
	}
	
	private _setFlightPriceInCash(flightCost, currency) {
		if (this.isBookAward) {
			this.miles = { amount: flightCost, currency: 'M' };
		} else {
			this.cash = { amount: flightCost, currency: currency };
		}
	}
	
	private _setFlightTax(tax, currency) {
		this.tax = { amount: (tax ? tax : 0), currency: currency};
	}
	
	public getFlightCost(): string {
		if (this.isBookAward) {
			return this.miles.amount.toFixed(0) + ' ' + 
				this.miles.currency + ' + ' + 
				this.tax.amount + ' ' + 
				this.tax.currency;
		} else {
			return this.cash.amount + ' ' + this.cash.currency;
		}
	}
}


export interface INDRATotalFlightPrice {
	cash: number;
	miles: number;
	currency: string;
}

export interface INDRAFlightPriceSummary {
	status: string;
	errors: any[];
	paymentMethods: number;
	bookingTotal: {
		amount: number;
		miles: number;
		surcharge: number;
		adminFee: number;
		oldPrice: number;
		currency: string;
	};
	totalDiscount: {
		amount: number;
		miles: number;
		currency: string;
	};
	flightCost: {
		price: number;
		miles: number;
		oldPrice: number;
		currency: string;
	};
	ancillaries: INDRAFlightAncillaryPrice[],
	thirdPartyExtras: INDRAFlightThirdPartyExtraPrice[];
	promocodeVouchers: INDRAFlightVoucherPromocode[];
	customerLogged: boolean;
	pointsUsed: boolean;
}

export interface INDRAFlightAncillaryPrice {
	payWithMiles: boolean;
	type: string;
	price: number;
	currency: string;
	miles: number;
	oldPrice: number;
	discounted: false;
}

export interface INDRAFlightThirdPartyExtraPrice {
	type: string;
	price: number;
	currency: string;
}

export interface INDRAFlightVoucherPromocode {
	code: string;
	amount: number;
	miles: number;
	currency: string;
}